import React, { useState, useEffect, useRef } from 'react'

import { Notification } from '../../components'

import AdHocReportingImg from '../../assets/icons/ui/light-bulbs/ad-hoc-reporting.svg'
import LightIssueReportedImg from '../../assets/icons/ui/light-bulbs/light-issue-reported.svg'
import NotOurLightImg from '../../assets/icons/ui/light-bulbs/not-our-light.svg'
import WorkingLightImg from '../../assets/icons/ui/light-bulbs/working-light.svg'
import { ReactComponent as LegendTriggerIcon } from '../../assets/icons/ui/light-bulbs/help-light-bulb.svg'

export const WorkingLightIcon = () => {
  return (<img src={WorkingLightImg} alt='Working Light Icon' />)
}
export const AdHocReportingIcon = () => {
  return (<img src={AdHocReportingImg} alt='AD HOC Reporting Icon' />)
}
export const LightIssueReportedIcon = () => {
  return (<img src={LightIssueReportedImg} alt='Light Issue Reported Icon' />)
}
export const NotOurLightIcon = () => {
  return (<img src={NotOurLightImg} alt='Not Our Light Icon' />)
}

const GoogleMapLegend = () => {
  const [ legendVisibility, setLegendVisibility ] = useState(false)
  const legendVisibilityRef = useRef(null)

  const handleLegendTriggerClick = () => {
    setLegendVisibility(!legendVisibility)
  }
  
  useEffect(() => {
    const el = legendVisibilityRef.current
    if(legendVisibility) {
      el && el.classList.add("-show-legend")
    } else {
      el && el.classList.remove("-show-legend")
    }
  })
  
  return (
    <>
      <Notification Icon={LegendTriggerIcon} className="legend-trigger hidden-desktop" onClick={handleLegendTriggerClick} />
      <div className="map-legend-container" ref={legendVisibilityRef}>
        <Notification Icon={WorkingLightIcon} className="">Working Light</Notification>
        <Notification Icon={AdHocReportingIcon} className="">AD HOC Reporting</Notification>
        <Notification Icon={LightIssueReportedIcon} className="">Light Issue Reported</Notification>
        <Notification Icon={NotOurLightIcon} className="">Not Our Light</Notification>
      </div>
      
    </>
  )
}

export default GoogleMapLegend
